import { useState } from "react";
import axios from "axios";
import { Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/adresseingabe`;

export const PasswordGate = ({ onSuccess, title = "Adresseingabe", subtitle }) => {
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!pwd) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth`, { password: pwd });
      toast.success("Zugang gewährt");
      onSuccess(data.token);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Falsches Passwort");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="gate-screen"
      className="min-h-screen flex items-center justify-center px-6"
    >
      <div className="max-w-md w-full">
        <div className="text-center">
          <div className="inline-flex w-14 h-14 rounded-full bg-[#0a1128] text-white items-center justify-center mb-8">
            <Lock className="w-5 h-5 text-[#d90429]" />
          </div>
          <div className="eyebrow text-[#d90429] mb-3">Geschützter Bereich</div>
          <h1 className="font-display font-bold text-[40px] md:text-[56px] leading-[0.95] tracking-tight">
            {title}
          </h1>
          <p className="mt-5 text-[#505a74] text-[15px] leading-relaxed">
            {subtitle ||
              "Diese Seite ist passwortgeschützt. Bitte geben Sie das Zugangs-Passwort ein, um zum Formular zu gelangen."}
          </p>
        </div>

        <form onSubmit={submit} className="mt-10">
          <label className="block">
            <span className="eyebrow text-[#505a74]">Passwort</span>
            <input
              type="password"
              autoFocus
              data-testid="gate-input-password"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              className="mt-2 block w-full bg-white border border-[#e8e6df] rounded-sm px-4 py-3 text-[15px] focus:outline-none focus:border-[#0a1128] transition"
              placeholder="••••••••"
            />
          </label>
          <button
            type="submit"
            disabled={loading || !pwd}
            data-testid="gate-submit"
            className="btn-primary mt-6 w-full px-6 py-3.5 rounded-full text-[13px] font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {loading ? "Prüfe…" : "Weiter"}
            <ArrowRight className="w-4 h-4" />
          </button>
        </form>

        <p className="mt-10 text-[11px] text-[#505a74] text-center leading-relaxed">
          Rechtsanwalt M. O. Keller · Hauptstraße 79, 53797 Lohmar
        </p>
      </div>
    </div>
  );
};
